/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

/**
 * This file contains api specific constants
 */

/**
 * CONTEXT for api requests
 */
export const CONTEXT: string = "/b/";
/**
 * 'X-Origin' header for all api requests, this header contains original college site host name
 */
export const HEADER_XORIGIN: string = "X-Origin";
